import { splitRoutePathSegments } from '@common/core-layer/utils/route-path-segments'

const CONTENT_UNAVAILABLE_SEGMENT = 'content-unavailable'

const GROUP_ROUTE_CHILD_SEGMENTS = new Set([
  'home',
  'about',
  'learning',
  'settings',
  'members',
  'events',
  'leaderboard',
  'conversations',
  'channels',
  CONTENT_UNAVAILABLE_SEGMENT,
])

/**
 * Extract the group slug from a member-facing community route path.
 * Returns null for non-group routes (discovery, settings outside layout, etc.).
 */
export function resolveCommunityGroupSlugFromPath(path: string | null | undefined): string | null {
  if (!path?.trim()) return null

  const normalized = path.replace(/\/+$/, '')
  if (normalized.includes(`/${CONTENT_UNAVAILABLE_SEGMENT}`)) return null

  const segments = splitRoutePathSegments(normalized)

  if (segments[0] === 'communities' && segments[1] === 'groups') {
    const slug = segments[2]?.trim()
    return slug || null
  }

  const slug = segments[0]?.trim()
  const childSegment = segments[1]
  if (!slug || !childSegment || !GROUP_ROUTE_CHILD_SEGMENTS.has(childSegment)) return null

  return slug
}
